import { render, staticRenderFns } from "./InformeControlDeAccesos.vue?vue&type=template&id=26ddfc54"
import script from "./InformeControlDeAccesos.vue?vue&type=script&lang=js"
export * from "./InformeControlDeAccesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports